import React, { useEffect, useLayoutEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import UserService from "../../../services/user-auth/user.service";

import { BsBan } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
import { FiCheckSquare } from "react-icons/fi";
import UserResponsiveCards from "../usersResponsiveCard";
import ReactPaginate from "react-paginate";
import { showErrorToaster } from "../../../components/toaster/error";
import DataTableDisplay from "../../../components/tableMission";
import AppButton from "../../../components/appButton";
const userService = new UserService();

function UserListePages() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await userService?.getAllusers();
      setUsers(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  const handleStatus = async (id) => {
    setIsLoading(true);

    try {
      await userService?.toggleUserStatus(id);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(userId) {
    return `${apiUrl}/users/${userId}/image`;
  }

  const columnsuser = [
    {
      name: "Nom",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.name != null && row?.name}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.email != null && row?.email}
        </div>
      ),
      sortable: true,
    },
    {
      name: "image",
      selector: (row) => (
        <div className="table-text capitalize">
          <img
            src={getImageURL(row?._id)}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
      ),
      sortable: true,
    },

    {
      name: "Role",
      selector: (row) => (
        <div className="table-text">{row?.role != null && row?.role}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <button
            className="btn btn-link"
            onClick={() => {
              navigate(`/edit-user/${row?._id}`);
              window.scrollTo(0, 0);
            }}>
            <label className="mx-1">
              <FaEdit />
            </label>
          </button>
          <button
            className="btn btn-link"
            onClick={async () => {
              await handleStatus(row?._id);
              await loadData();
            }}
            type="button">
            {row?.status === "enabled" ? (
              <label className="mx-1">
                <BsBan style={{ color: "#EE0202" }} />
              </label>
            ) : (
              <label className="mx-1">
                <FiCheckSquare style={{ color: "#00AC0E" }} />
              </label>
            )}
          </button>
        </div>
      ),
    },
  ];
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3; // Adjust this number as needed

  // Calculate the offset
  const offset = currentPage * itemsPerPage;

  // Slice the missions list based on the current page and items per page
  const currentMissions = users.slice(offset, offset + itemsPerPage);
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row  my-0 my-md-5 align-items-center">
          <div className="col-auto">
            {" "}
            <h3>Utilisateur liste</h3>
          </div>

          <div className="col-auto ms-auto">
            <AppButton
              text="Ajouter utilisateur "
              color="bleu"
              size="medium"
              className="add-btn"
              onClick={() => {
                navigate("/add-user");
                window.scrollTo(0, 0);
              }}
            />
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex  my-0 my-md-5 justify-content-center align-items-center"></div>
        ) : (
          <div className=" my-0 my-md-5 py-2">
            {isMobile > 599 ? (
              <DataTableDisplay columns={columnsuser} data={users} />
            ) : (
              <>
                {users.map((item) => (
                  <UserResponsiveCards
                    key={item._id} // Ensure the key is unique for each item
                    handleStatus={handleStatus}
                    user={item}
                    loadData={loadData}
                  />
                ))}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={Math.ceil(users.length / itemsPerPage)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default UserListePages;
